import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions'
import {Maybe} from '../../utils/logging';
import _ from 'lodash';

class Step extends Component {

    renderP(details) {
        const pTags = [];
        let counter = 0;
        details.forEach((text, index) => {
            pTags.push(<p className='content' key={counter}>{text} {index === 0 ? this.props.value : ''}</p>);
            counter ++;
        });
        return pTags;
    }

    render() {
        return (
            <li className='step-item' id={`step-${this.props.stepNo}`}>
                <div className='step-text'>
                    <p className='title'>{this.props.name}</p>
                    {this.renderP(this.props.details)}
                    <hr className='divider-line' />
                    {/*<div className='divider-element'></div>*/}
                </div>
                <div className='circle'>
                    <div className='main-circle'></div>
                </div>
            </li>
        );
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
Step.propTypes = {
    currentStep: PropTypes.number,
    stepNo:      PropTypes.number,
    name:        PropTypes.string,
    details:     PropTypes.array,
    value:       PropTypes.string,
};

function mapStateToProps({summary}) {
    return {
        summary
    }
}

export default connect(mapStateToProps, actions)(Step);



// WEBPACK FOOTER //
// ./src/components/parts/Step.js